import request from '@/utils/request'

const url = 'admin/system.dict_data'
/**
 * 系统-字典数据表接口API
 */

const api = {
  Drop(data) {
    return request({
      url: `${url}/drop`,
      method: 'post',
      data
    })
  },
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
   * 添加DictData
   * @returns
   */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
   * 编辑DictData
   * @returns
   */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
   * 删除DictData
   * @returns
   */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
   * 详情DictData
   * @returns
   */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
   * 更改DictData数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/changeStatus`,
      method: 'post',
      data
    })
  },
  getAppointList(data) {
    return request({
      url: `${url}/getAppointList`,
      method: 'post',
      data
    })
  }

}

export default api
